import { systemIds } from '@/shared/utils';
const commonFunc = (path) => {
    return {
        path: path,
        systemId: systemIds['mechanicalTeam'], // 为了获取基础路由
    };
};
export const mechanicalTeamToPathNameMap = {
    ls4000: ({ businessKey }) => commonFunc(`/no-login-h5/mechanical-team/shift-registration/${businessKey}/detail`),
};
